import React from "react";
import { default as MUIFormControl } from "@mui/material/FormControl";
import { useTheme } from "@mui/material/styles";
import styled from "styled-components";

const StyledMUIFormControl = styled(MUIFormControl)`
  margin: ${({ theme }) => theme.spacing(1)}px !important;
  min-width: 120px !important;

  &.selectEmpty {
    margin-top: ${({ theme }) => theme.spacing(2)}px;
  }
`;

export const FormControl = (props) => {
  const theme = useTheme();
  return <StyledMUIFormControl theme={theme} {...props} />;
};
